import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const BusinessAnalystManagerdMenu = () => {
    function logoutUser() {
        localStorage.clear();
        window.location.replace('/login');
    }
    const location = useLocation();
    const userType = JSON.parse(localStorage.getItem('user'));
    const [isOpen, setIsOpen] = useState(false);

    const toggleSubMenu = () => {
        setIsOpen((prev) => !prev);
    };

    const [isOpenDestination, setIsOpenDestination] = useState(false);

    const toggleSubMenuDestination = () => {
        setIsOpenDestination((prev) => !prev);
    };

    return (
        <>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <a href="#" className="brand-link text-center d-none d-md-block">
                    <img
                        src="../assets/img/logo.webp"
                        style={{ width: "100px", margin: '0 auto !important' }}
                        alt="Superbmytrip Logo"
                        className="brand-image elevation-3"
                    />
                    <img
                        src="../assets/img/favicon.webp"
                        style={{ width: "30px", margin: '0 auto !important' }}
                        alt="Superbmytrip Logo"
                        className="brand-image elevation-3 img2"
                    />
                </a>
                {/* Sidebar */}
                <div className="sidebar">
                    <nav className="mt-2">
                        <ul
                            className="nav nav-pills nav-sidebar flex-column"
                            data-widget="treeview"
                            role="menu"
                            data-accordion="false"
                        >

                            <li className="nav-item">
                                <Link
                                    to="dashboard"
                                    className={
                                        location.pathname === "/dashboard"
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <i className="nav-icon fas fa-tachometer-alt" />
                                    <p>
                                        Dashboard
                                        {/* <i className="right fas fa-angle-left" /> */}
                                    </p>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="coupons"
                                    className={
                                        location.pathname === "/coupons"
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <i className="nav-icon fas fa-percent"></i>
                                    <p>
                                        Coupons
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>



                            <li className="nav-item">
                                <Link
                                    to="price-fare-rule"
                                    className={
                                        location.pathname === "/price-fare-rule" ||
                                            location.pathname.startsWith("/edit-price-fare-rule/") ||
                                            location.pathname === "/add-price-fare-rule" ||
                                            location.pathname.startsWith("/add-price-fare-rule/")
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <i className="nav-icon fas fa-hand-holding-usd"></i>
                                    <p>
                                        Price Fare Rule
                                    </p>
                                    <span className="right badge badge-danger">New</span>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="price-list"
                                    className={
                                        location.pathname === "/price-list"
                                            ? "nav-link active"
                                            : "nav-link"
                                    }


                                >

                                    <i className="nav-icon fa fa-tag"></i>
                                    <p>
                                        Flight Price List
                                        <span className="right badge badge-danger">New</span>
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="hotel-price-list" className={location.pathname === "/hotel-price-list" ? "nav-link active" : "nav-link"}
                                >
                                    <i className="nav-icon fa fa-hotel"></i>
                                    <p>
                                        Hotel Price List
                                        {/* <span className="right badge badge-danger">New</span> */}
                                    </p>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="flight-bookings"
                                    className={
                                        location.pathname === "/flight-bookings" || location.pathname.startsWith("/booking-detail/")
                                            ? "nav-link active"
                                            : "nav-link"
                                    }

                                >
                                    {/* <i className="nav-icon fas-solid fa-plane"></i> */}
                                    <i className="nav-icon fas fa-plane" />
                                    <p>
                                        Flight Bookings
                                    </p>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="hotel-bookings"
                                    className={
                                        location.pathname === "/hotel-bookings" || location.pathname.startsWith("/hotel-detail/")
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >

                                    <i className="nav-icon fas fa-solid fa-hotel" />
                                    <p>
                                        Hotel Bookings
                                    </p>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="holiday-bookings"
                                    className={
                                        location.pathname === "/holiday-bookings" || location.pathname.startsWith("/Holiday-detail/")
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                >
                                    <i className="nav-icon fas fa-umbrella-beach" />
                                    <p>
                                        Holiday Bookings
                                    </p>
                                </Link>
                            </li>

                  

                           

                            <li className="nav-item">
                                <Link
                                    onClick={toggleSubMenu}
                                    className="nav-link"
                                >
                                    <i className="nav-icon fas fa-list"></i>
                                    <p>
                                        Manage Packages
                                        <i className={`right fas fa-angle-left ${isOpen ? "open" : ""}`} />
                                    </p>
                                </Link>

                                <ul
                                    className="nav nav-treeview"
                                    style={{ display: isOpen ? "block" : "none" }} // Force display based on isOpen
                                >
                                    <li className="nav-item">
                                        <Link
                                            to="/package-list"
                                            className={`nav-link ${location.pathname === "/package-list" ? "active" : ""
                                                }`}
                                        >
                                            <i className="nav-icon fas fa-clipboard-list"></i>
                                            <p>Packages List</p>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/category-list"
                                            className={`nav-link ${location.pathname === "/category-list" ? "active" : ""
                                                }`}
                                        >
                                            <i className="nav-icon fas fa-clipboard-list"></i>
                                            <p>Category List</p>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/destination-list"
                                            className={`nav-link ${location.pathname === "/destination-list" ? "active" : ""
                                                }`}
                                        >
                                            <i className="nav-icon fas fa-umbrella-beach"></i>
                                            <p>Destination List</p>
                                        </Link>
                                    </li>
                                     <li><Link
                                                        to="feedbacks"
                                                        className={
                                                          location.pathname === "/feedbacks" ||
                                                            location.pathname.startsWith("/edit-feedback/") ||
                                                            location.pathname === "/add-feedback" ||
                                                            location.pathname.startsWith("/add-feedback/")
                                                            ? "nav-link active"
                                                            : "nav-link"
                                                        }
                                                      >
                                                        <i className="nav-icon fas fas fa-star"></i>
                                                        <p>
                                                         &nbsp;Feedback List
                                                        </p>
                                                      </Link></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <a
                                    href="#"
                                    onClick={toggleSubMenuDestination}
                                    className="nav-link"
                                >
                                    <i className="nav-icon fas  fa-map"></i>
                                    <p>  Destination <i className={`right fas fa-angle-left ${isOpenDestination ? "open" : ""}`} /></p>
                                </a>

                                <ul className="nav nav-treeview"
                                    style={{ display: isOpenDestination ? "block" : "none" }}>
                                    <li>
                                        <Link
                                            to="manage-airport-destinations-list"
                                            className={
                                                location.pathname === "/manage-airport-destinations-list" ||
                                                    location.pathname.startsWith("/edit-package/") ||
                                                    location.pathname === "/add-tour-and-packages" ||
                                                    location.pathname.startsWith("/add-tour-and-packages/")
                                                    ? "nav-link active"
                                                    : "nav-link"
                                            }
                                        >
                                            <i className="nav-icon fas fa-plane"></i>
                                            <p>
                                                Manage Airport
                                            </p>
                                        </Link>
                                    </li>
                                    <li><Link
                                        to="popular-airPort-destination"
                                        className={
                                            location.pathname === "/popular-airPort-destination" ||
                                                location.pathname.startsWith("/edit-manage-airport-destination/") ||
                                                location.pathname === "/add-popular-airPort-destination" ||
                                                location.pathname.startsWith("/add-manage-airport-destinations/")
                                                ? "nav-link active"
                                                : "nav-link"
                                        }
                                    >
                                        <i className="nav-icon fas fa-plane-departure"></i>
                                        <p>
                                            Popular Airport
                                        </p>
                                    </Link></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    style={{ cursor: "pointer" }}
                                    onClick={logoutUser}
                                >
                                    <i className="nav-icon fas fa-lock" />
                                    <p>
                                        Logout
                                    </p>
                                </Link>
                            </li>

                        </ul>
                    </nav>
                </div>


            </aside>
        </>
    );
};

export default BusinessAnalystManagerdMenu;
